import React from 'react'

type Props = { src: string }
const Circle: React.FC<Props> = ({ src }) => {
  const style = {background: `url(${src}) no-repeat center center`, backgroundSize: 'cover'}
  return (
    <div style={style} className='w-5 h-5 rounded-full' />
  )
}

export default Circle
